<template>
  <router-link class="dash-card" :to="link">
    <div class="level is-mobile">
      <div class="level-left">
        <h4 class="title is-4">
          <span class="icon is-medium">
            <i class="fas" :class="card.icon"></i>
          </span>
          <span>{{ card.title }}</span>
        </h4>
      </div>
      <div class="level-right">
        <div class="title num opacity" :class="sizeClass">{{ card.total }}</div>
      </div>
    </div>

    <div
      class="is-flex is-flex-wrap-wrap"
      style="justify-content: space-around"
    >
      <div
        class="has-text-centered p-2"
        v-for="(item, index) in card.data"
        :key="index"
      >
        <div class="title is-6 has-text-weight-bold opacity">
          {{ item.title }}
        </div>
        <div class="subtitle has-text-weight-bold opacity" :class="sizeClass">
          {{ item.count }}
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "DashCard",
  props: {
    card: {
      type: Object,
      default() {
        return {
          size: "normal",
          title: "Data",
          icon: "",
          link: "#",
          total: 0,
          data: [],
        };
      },
    },
  },

  computed: {
    link() {
      return this.card.link ? this.card.link : "#";
    },
    sizeClass() {
      switch (this.card.size) {
        case "small":
          return "is-3";
        case "normal":
          return "is-2";
        case "large":
          return "is-1";

        default:
          return "is-1";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dash-card {
  position: relative;
  display: block;
  width: 100%;
  background: linear-gradient(180deg, #0bab64 0%, #3bb78f 100%);
  border-radius: 5px;
  overflow: hidden;
  padding: 5px;

  .opacity {
    opacity: 0.8;
  }

  .level {
    padding: 1rem;
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      color: $defaultColor;

      &.num {
        position: absolute;
        font-weight: bold;
        font-style: italic;
        right: 0.5rem;
        text-shadow: 0 0 3px #000;
      }

      &.is-1 {
        top: -0.8rem;
        font-size: 6rem;
      }

      &.is-2 {
        top: -0.8rem;

        font-size: 4rem;
      }

      &.is-3 {
        top: 0.2rem;
        font-size: 3rem;
      }

      .icon {
        margin-right: 0.5rem;
      }
    }
  }

  .data-list {
    margin: 3rem 0 0;
    .title {
      color: #000;
    }
    .subtitle {
      color: $defaultColor;
    }
  }
}
</style>
